import React from "react";
import { useWindowSize } from '../../Helpers'
import ModuleFactory from '../../Modules/ModuleFactory'
import SidebarModuleFactory from '../../SidebarModules/SidebarModuleFactory'
import TitleArea from '../../Components/TitleArea'
import WYSIWYGContent from '../../Components/WYSIWYGContent'
import {
  Padding,
  ContentContainer,
  ContentWrapper,
  GridContainer,
  GridItem,
} from '../../../styles'

export default function LeftSidebarTemplate({
  title,
  content,
  modules,
  sidebarModules,
}) {
  // vars
  const windowSize = useWindowSize()
  let gap = '5%'
  let columns = '25% 70%'
  let rows = 'auto'
  if ('mobile' === windowSize.currDevice) {
    gap = '5em'
    columns = 'repeat(1,100%)'
    rows = 'repeat(2,auto)'
  } else if ('tablet' === windowSize.currDevice) {
    gap = '5em'
    columns = 'repeat(1,100%)'
    rows = 'repeat(2,auto)'
  }

  const hasHero =
    modules &&
    modules.some(
      (module) =>
        module &&
        ("hero" === module.section_name || "qip_hero" === module.section_name)
    );

  return (<ContentContainer>
    {Boolean(title) && !hasHero
      && <TitleArea title={title} area="pages" />}
    <ContentWrapper
      currDevice={windowSize.currDevice}
    >
      <GridContainer
        gap={gap}
        columns={columns}
        rows={rows}
        padding={`${Padding.padding2} ${Padding.padding3}`}
      >
        <GridItem>
          {sidebarModules
            && sidebarModules.map((module, i) => (
              <SidebarModuleFactory
                key={i}
                module={module}
              />
            ))}
        </GridItem>
        <GridItem>
          <WYSIWYGContent content={content} />
          {modules.map((module, i) => (
            <ModuleFactory
              module={module}
              key={i}
            />
          ))}
        </GridItem>
      </GridContainer>
    </ContentWrapper>
  </ContentContainer>);
}
